import React from "react";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";

export default function EmploymentStatusField({ value, onChange }) {
  const handleChange = (e) => {
    onChange({ employment: e.target.checked });
  };

  return (
    <>
      <Grid
        item
        xs={4}
        sm={2}
        sx={{
          fontWeight: "bold",
          paddingLeft: { sm: "20px" },
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        技術提供主(要員)の雇用形態
      </Grid>

      <Grid
        item
        xs={8}
        sm={3.5}
        sx={{
          paddingLeft: "20px",
          paddingTop: "10px",
          paddingBottom: "20px",
        }}
      >
        <FormControlLabel
          control={<Checkbox checked={!!value} onChange={handleChange} />}
          label="正社員・契約社員のみ"
          id="employment"
        />
      </Grid>
    </>
  );
}